require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-blueprintjs-labs.json") })
        }
      }, "path---package-bs-blueprintjs-labs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-blueprintjs-labs!./.cache/json/package-bs-blueprintjs-labs.json
// module id = 762
// module chunks = 231608221292675